import type { Unsubscribe, WebContainer, WebContainerProcess } from "@webcontainer/api";
import { Readable } from "stream";
import type FileData from "~~/package/types/FileData";
import type { LearningFileSystemTree } from "~~/package/types/LearningFileSystemTree";
import { LinuxInstructionModel } from "~~/package/mapper/learning/model/linux/LinuxInstructionModel";
import {
    ProSkillAssureAssessmentModel
} from "~~/package/mapper/proSkillAssure/model/assessment/ProSkillAssureAssessmentModel";
import {
    ProSkillAssureAssessmentMyInfoModel
} from "~~/package/mapper/proSkillAssure/model/assessment/myInfo/ProSkillAssureAssessmentMyInfoModel";

interface AwsCredentials {
    accessKeyId: string;
    secretAccessKey: string;
    sessionToken?: string;
}

export const createTrackInfoState = () => ({
    title: "",
    levelId: "",
    trackLevel: "",
    trackLevelTitle: ""
});

export const createLevelAssessmentState = () => ({
    timerIntervalId: -1
});

export const createDirectoryState = (): {
    credentials?: AwsCredentials | null;
    credentialProvider?: any;
    isInitCredentials: boolean;
    isInitDirectory: boolean;
    tree: LearningFileSystemTree;
    rollbackTree: LearningFileSystemTree;
    selectedFiles: FileData[];
    rollbackPathList: string[];
    isUploaded: boolean | null;
    isHideFile: boolean[];
    modifiedFiles: FileData[];
    validSetTree: LearningFileSystemTree;
    analysisSetTree: LearningFileSystemTree;
} => ({
    isInitCredentials: false,
    isInitDirectory: false,
    tree: {},
    rollbackTree: {},
    selectedFiles: [],
    rollbackPathList: [],
    isUploaded: null,
    isHideFile: [],
    modifiedFiles: [],
    validSetTree: {},
    analysisSetTree: {}
});

export const createFrontLearningState = (): {
    webContainer: WebContainer | null;
    iframeEnable: boolean;
    defaultLocation: string;
    currentLocation: string;
    webContainerProcessList: WebContainerProcess[];
    webContainerTestProcessList: WebContainerProcess[];
    unsubscribeList: Unsubscribe[];
    testResult: string;
    nodeModules: {[key:string]: Buffer|Uint8Array|Blob|string|Readable};
    terminalStreamData: string[];
    isShowToastMessage: boolean;
} => ({
    webContainer: null,
    iframeEnable: true,
    defaultLocation: "",
    currentLocation: "",
    webContainerProcessList: [],
    webContainerTestProcessList: [],
    unsubscribeList: [],
    testResult: "",
    nodeModules: {},
    terminalStreamData: [],
    isShowToastMessage: false
});

export const createLinuxLearningState = (): {
    instructionList: LinuxInstructionModel[];
    isInstructionAllDone: boolean;
} => ({
    instructionList: [],
    isInstructionAllDone: false
});

export const createProSkillAssureState = () => ({
    assessmentId: 0,
    assessment: new ProSkillAssureAssessmentModel(),
    myInfo: new ProSkillAssureAssessmentMyInfoModel(),
    timer: {
        isStart: false,
        elapsedTime: 0,
        remainingTime: 0,
        timerIntervalId: -1,
        extensionHistory: [] as { count: number; addedSeconds: number; receivedAt: string }[],
        totalAddedSeconds: 0,
        extensionFlashActive: false,
    },
    theFirstOpenTabChangeCautionPopup: true,
    isCheckedAPIReference: false
});

export const createExternalDirectorState = () => ({
    camId: null,
    micId: null
});
